import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["valueField"];
  static values = {};

  // 값 입력이 필요 없는 연산자들
  static noValueOperators = ["is_present", "is_blank"];

  connect() {
    // 폼 연결 시 초기화
  }

  disconnect() {
    // 폼 연결 해제 시 정리
  }

  // Operator 변경 시 호출
  operatorChanged(event) {
    const operator = event.target.value;
    const ruleContainer = event.target.closest("[data-controller='subscription-group-rules--form']");
    if (!ruleContainer) return;

    const valueField = ruleContainer.querySelector("[data-subscription-group-rules--form-target='valueField']");
    if (!valueField) return;

    if (this.constructor.noValueOperators.includes(operator)) {
      valueField.style.display = "none";
    } else {
      valueField.style.display = "";
    }
  }
}
